import type { RouteDefinition } from 'svelte-spa-router';
import SummaryPage from '../features/top/SummaryPage.svelte';
import CategoryMgmtPage from '../features/category-mgmt/CategoryMgmtPage.svelte';
import CategoryDetailPage from '../features/category-detail/CategoryDetailPage.svelte';
import DailyExpenseListPage from '../features/category-detail/DailyExpenseListPage.svelte';
import ExpenseFormPage from '../features/expense-form/ExpenseFormPage.svelte';
import ReportPage from '../features/report/ReportPage.svelte';
import SettingsPage from '../features/settings/SettingsPage.svelte';

/**
 * ルーティングマップ（docs/pm/CONTRACTS.md §5 準拠）
 * Phase 2完了により全ルートが実コンポーネントに統合済み。
 */
const routes: RouteDefinition = {
  '/': SummaryPage, // [TOP_CATEGORY_MGMT]
  '/category-mgmt': CategoryMgmtPage, // [TOP_CATEGORY_MGMT]
  '/category/:categoryId': CategoryDetailPage, // [DETAIL_EXPENSE_FORM]
  '/category/:categoryId/day/:date': DailyExpenseListPage, // [DETAIL_EXPENSE_FORM]
  // 実際の遷移では ?date=YYYY-MM-DD をクエリストリングとして付与する（パス自体には含めない）
  '/category/:categoryId/expense/new': ExpenseFormPage, // [DETAIL_EXPENSE_FORM]
  '/category/:categoryId/expense/:expenseId/edit': ExpenseFormPage, // [DETAIL_EXPENSE_FORM]
  '/report': ReportPage, // [REPORT]
  '/settings': SettingsPage, // [SETTINGS]
};

export default routes;
